module.exports = __webpack_public_path__ + "img/USDC.e97cf061.png";